<template>
  <div class="p-6 bg-gradient-to-br from-gray-50 to-gray-100 min-h-screen">
    <div class="flex justify-between items-center mb-6">
      <h1 class="text-2xl font-bold text-gray-800 inline-block transition-all duration-500">
        <span
            class="bg-clip-text text-transparent bg-gradient-to-r from-purple-500 via-pink-500 to-blue-500 hover:animate-pulse">
          گزارشات
        </span>
      </h1>
      <div class="flex gap-3 mr-3">
        <button
            @click="refreshIssues"
            class="p-2 bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-300 hover:bg-gray-50 transform hover:scale-105"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-600" fill="none" viewBox="0 0 24 24"
               stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
          </svg>
        </button>
      </div>
    </div>
    <div
        class="bg-white bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-xl p-3 mb-6 shadow-sm border border-gray-100">
      <div class="flex flex-wrap items-center gap-2">


        <select
            @change="applyFilters"
            v-model="filters.issue_type"
            class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-32 text-right"
        >
          <option value="">همه نوع‌ها</option>
          <option value="bug">باگ</option>
          <option value="feature">قابلیت جدید</option>
        </select>

        <select
            @change="applyFilters"
            v-model="filters.status"
            class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-32 text-right"
        >
          <option value="">همه وضعیت‌ها</option>
          <option value="new">جدید</option>
          <option value="in_progress">در حال انجام</option>
          <option value="done">انجام شد</option>
        </select>
        <div class="flex gap-1">
          <button
              @click="resetFilters"
              class="p-1.5 bg-gradient-to-r from-gray-500 to-blue-600 text-white rounded-full shadow-sm hover:shadow-md transition-all duration-300 transform hover:scale-105"
              title="حذف فیلترها"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
            </svg>
          </button>

          <button
              @click="applyFilters"
              class="p-1.5 bg-gradient-to-r from-red-500 to-blue-600 text-white rounded-full shadow-sm hover:shadow-md transition-all duration-300 transform hover:scale-105"
              title="اعمال فیلتر"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"/>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div
        class="bg-white bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-xl shadow-sm border border-gray-100 overflow-hidden">
      <div class="overflow-x-auto">
        <table class="min-w-full text-sm">
          <thead class="bg-gray-50 bg-opacity-70">
          <tr>
            <th class="p-3 text-center text-[8px] font-medium text-gray-500 uppercase tracking-wider">وضعیت</th>
            <th class="p-3 text-center text-[8px] font-medium text-gray-500 uppercase tracking-wider">نوع</th>
            <th class="p-3 text-center text-[8px] font-medium text-gray-500 uppercase tracking-wider">عنوان</th>
            <th class="p-3 text-center text-[8px] font-medium text-gray-500 uppercase tracking-wider">تاریخ</th>
            <th class="p-3 text-center text-[8px] font-medium text-gray-500 uppercase tracking-wider">توضیحات</th>
            <th class="p-3 text-center text-[8px] font-medium text-gray-500 uppercase tracking-wider w-[ppx]">تست</th>
          </tr>
          </thead>
          <tbody>
          <tr v-if="loading">
            <td colspan="6" class="p-4 text-center">
              <div class="flex justify-center items-center gap-2">
                <svg class="animate-spin h-5 w-5 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none"
                     viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                در حال بارگذاری...
              </div>
            </td>
          </tr>
          <tr v-else-if="issues.length === 0">
            <td colspan="6" class="p-4 text-center text-gray-500">
              گزارشی یافت نشد
            </td>
          </tr>
          <tr
              v-for="issue in issues"
              :key="issue.id"
              class="border-t border-gray-100 hover:bg-gray-50 transition-colors duration-200"
          >
            <td class="text-center">
              <span
                  class="px-1.5 py-0.5 rounded-full text-[8px] font-medium"
                  :class="{
                     'bg-yellow-100 text-yellow-800': issue.status === 'new',
                     'bg-blue-100 text-blue-800': issue.status === 'in_progress',
                     'bg-green-100 text-green-800': issue.status === 'done',
                   }">{{ getStatusLabel(issue.status) }}
              </span>
            </td>

            <td class="text-center">
              <span
                  class="px-1.5 py-0.5 rounded-full text-[8px] font-medium"
                  :class="{
                     'bg-pruple-100 text-pruple-800': issue.issue_type === 'feature',
                     'bg-red-100 text-red-800': issue.issue_type === 'bug',
                   }">{{ getTypeLabel(issue.issue_type) }}
              </span>
            </td>
            <td class="p-3 font-medium text-[9px] text-gray-900 text-center">{{ issue.title || ' بدون عنوان' }}</td>
            <td class="p-3 font-medium text-[7px] text-gray-900 text-center">{{ issue.created_at | toJalali }}</td>
            <td class="p-3 font-medium text-[6px] text-gray-900 text-center">{{ issue.description || ' - ' }}</td>

            <td class="p-3 font-medium text-[9px] text-gray-900 text-center">
              <span :class="{'text-green-400': issue.is_tested, 'text-red-400': !issue.is_tested}" class="text-sm">
                {{ issue.is_tested ? '✓' : '×' }}
              </span>

            </td>

          </tr>
          </tbody>
        </table>
      </div>

      <div class="p-4 border-t border-gray-100 flex flex-col md:flex-row justify-between items-center gap-4">
        <div class="text-[6px] text-gray-600">
          نمایش {{ (currentPage - 1) * itemsPerPage + 1 }} تا
          {{ Math.min(currentPage * itemsPerPage, totalIssues) }} از
          {{ totalIssues }} گزارش
        </div>
        <div class="flex gap-1">
          <button
              @click="prevPage"
              :disabled="currentPage === 1"
              class="p-2 border border-gray-200 rounded-lg bg-white bg-opacity-50 hover:bg-gray-50 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
              :class="{ 'opacity-50 cursor-not-allowed': currentPage === 1 }"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
            </svg>
          </button>
          <button
              v-for="page in visiblePages"
              :key="page"
              @click="goToPage(page)"
              class=" border border-gray-200 rounded-lg w-[30px] h-[30px] transition-colors duration-200"
              :class="{
              'text-center bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-md': page === currentPage,
              'text-center bg-white bg-opacity-50 hover:bg-gray-50': page !== currentPage,
              'text-center cursor-default': page === '...'
            }"
              :disabled="page === '...'"
          >
            {{ page }}
          </button>
          <button
              @click="nextPage"
              :disabled="currentPage * itemsPerPage >= totalIssues"
              class="p-2 border border-gray-200 rounded-lg bg-white bg-opacity-50 hover:bg-gray-50 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
              :class="{ 'opacity-50 cursor-not-allowed': currentPage * itemsPerPage >= totalIssues }"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IssuesList',
  data() {
    return {
      showQuickView: false,
      loading: true,
      issues: [],
      totalIssues: 0,
      currentPage: 1,
      itemsPerPage: 20,
      filters: {
        issue_type: '',
        status: '',
        search: ''
      },
    }
  },
  computed: {
    visiblePages() {
      const totalPages = Math.ceil(this.totalIssues / this.itemsPerPage)
      const range = 1
      const pages = []

      pages.push(1)

      if (this.currentPage - range > 2) {
        pages.push('...')
      }

      for (let i = Math.max(2, this.currentPage - range); i <= Math.min(totalPages - 1, this.currentPage + range); i++) {
        pages.push(i)
      }

      if (this.currentPage + range < totalPages - 1) {
        pages.push('...')
      }

      if (totalPages > 1) {
        pages.push(totalPages)
      }

      return pages
    },
  },

  methods: {
    getStatusLabel(status) {
      const statusMap = {
        'new': 'جدید',
        'in_progress': 'در حال انجام',
        'done': 'انجام شد',
      }
      if (!status) return ' '
      return statusMap[status] || status
    },
    getTypeLabel(type) {
      const typeMap = {
        'bug': 'باگ',
        'feature': 'قابلیت جدید',
      }
      if (!type) return ' '
      return typeMap[type] || type
    },

    showIssueQuickView(issue) {
    },
    fetchIssues() {
      this.loading = true

      const params = {
        limit: this.itemsPerPage,
        offset: (this.currentPage - 1) * this.itemsPerPage,
        ...this.filters
      }

      Object.keys(params).forEach(key => {
        if (params[key] === '') {
          delete params[key]
        }
      })

      this.request({
        url: this.endpoint('issues/own'),
        method: 'get',
        params,
        success: (data) => {
          this.issues = data.results
          this.totalIssues = data.count
          this.loading = false
        },
        error: () => {
          this.loading = false
        }
      })
    },

    applyFilters() {
      this.currentPage = 1
      this.fetchIssues()
    },

    resetFilters() {
      this.filters = {
        search_value: '',
        min_price: '',
        max_price: '',
        min_inventory: '',
        max_inventory: '',
        category_tree: '',
        brand_in: '',
        currency_in: ''
      }
      this.applyFilters()
    },

    refreshIssues() {
      this.fetchIssues()
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--
        this.fetchIssues()
      }
    },

    nextPage() {
      if (this.currentPage * this.itemsPerPage < this.totalIssues) {
        this.currentPage++
        this.fetchIssues()
      }
    },

    goToPage(page) {
      if (page !== '...') {
        this.currentPage = page
        this.fetchIssues()
      }
    },
  },
  mounted() {
    this.fetchIssues()
  }
}
</script>

<style>
/* RTL support */
body {
  direction: rtl;
  text-align: right;
}

/* Glass morphism effect */
.glass {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.18);
}

/* Neumorphism effect */
.neumorphism {
  border-radius: 16px;
  background: #f0f0f0;
  box-shadow: 8px 8px 16px #d9d9d9,
  -8px -8px 16px #ffffff;
}

/* Smooth transitions */
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.truncate-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100px; /* or whatever width you need */
}

</style>